import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { YgIconComponent } from './yg-icon.component';

@NgModule({
    imports:        [ CommonModule ],
    declarations:   [ YgIconComponent ],
    exports:        [ YgIconComponent ]
})
export class YgIconModule {
}
